import React, {useCallback} from 'react';
import {callAction} from 'client/framework';
import Checkbox from 'generic/Forms/Checkbox/Checkbox.react';

import usageReportsStore from '../UsageReports.store';
import usageReportsActions from '../UsageReports.actions';

const ExpandTeachersFilter = () => {
  const toggleExpandTeachers = useCallback(
    () => callAction(usageReportsActions.TOGGLE_EXPAND_TEACHERS),
    []
  );
  return (
    <Checkbox
      label='Expand teachers'
      checked={usageReportsStore.areTeachersExpanded()}
      onChange={toggleExpandTeachers}
    />
  );
};

export default ExpandTeachersFilter;
